import { createAction, props } from '@ngrx/store';
import { BankAccountList } from '../../interfaces';

enum BankAccountListActionIds {
    loadBankAccountList = '[Bank Account List] Load Bank Account List',
    setBankAccountList = '[Bank Account List] Set Bank Account List',
    resetBankAccountList = '[Bank Account List] Reset Bank Account List',
}

export const LoadBankAccountListAction = createAction(
    BankAccountListActionIds.loadBankAccountList
);

export const SetBankAccountListAction = createAction(
    BankAccountListActionIds.setBankAccountList,
    props<BankAccountList>()
);

export const ResetBankAccountListAction = createAction(
    BankAccountListActionIds.resetBankAccountList
);